import { Swiper, Navigation, Pagination, EffectFade, Autoplay } from 'swiper/core';
Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

export default () => {

  const k = {};
  const init = () => {
    k.root = document.getElementById('ticket-top-keyvisual');
    if (!k.root) {
      return;
    }

    buildSwiper();
  }

  const buildSwiper = () => {
    const container = k.root.querySelector('.ti-keyvisual__container');

    const slideCount = container.querySelectorAll('.ti-keyvisual__slide').length;
    if (slideCount == 1) {
      container.classList.add('no-swiper');
      return;
    }

    const pagination = k.root.querySelector('.ti-keyvisual__pagination');
    const prevBtn = k.root.querySelector('.ti-keyvisual__prev');
    const nextBtn = k.root.querySelector('.ti-keyvisual__next');

    const swiperOption = {
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 5000
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: pagination,
        bulletActiveClass: '-active',
        bulletClass: 'ti-keyvisual__pagination-item'
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      }
    }
    k.swiper = new Swiper(container, swiperOption)
  }

  init();
}
